import './App.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import {useEffect, useState} from "react";
import ReactPlayer from 'react-player'
import { IoCloseOutline } from "react-icons/io5";

function App() {
    const [user, setUser] = useState({});
    const [recordings, setRecordings] = useState([]);
    const [selectedRecording, setSelectedRecording] = useState(null)
    const API_URL = 'https://momt-api.kulacourts.com/v1'
    const SUPPORT_EMAIL = 'komunestudio@gmail.com'

    function getParam(param) {
        return new URLSearchParams(window.location.search).get(param);
    }

    const handleCopyClick = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            alert('Link copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy text: ', err);
            alert('Failed to copy link.');
        }
    };

    useEffect(() => {


        fetch(getParam("user_id") === '1' ? `${API_URL}/recording/latest-two` : `${API_URL}/recording/${getParam("user_id")}/selected`).then(response => response.json()).then(data => {
            // fetch(`${API_URL}/recording/latest-two`).then(response => response.json()).then(data => {
            setRecordings(data?.recordings)
            setUser(getParam("user_id") === '1' ? {name: 'Renaldy'} : data?.user)

            if(data?.user?.deleted_at) {
                alert('Link has been expired')
                window.open('https://komunestudio.com', '_self')
            }
            // setUser({name: 'Renaldy'})
        })
    }, []);

    return (
        <Container fluid>
            {selectedRecording &&
                <div style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999}}>
                    <div style={{position: 'fixed', top: 24, right: 24, zIndex: 10000}}>
                        <IoCloseOutline color={'white'} size={60} onClick={() => setSelectedRecording(null)}
                                        style={{cursor: 'pointer'}}/>
                    </div>

                    {selectedRecording.recording_file &&
                        <ReactPlayer url={selectedRecording.recording_file} width={'100%'} height={'100%'}
                                     style={{backgroundColor: 'black'}} controls={true}/>
                    }
                </div>
            }

            <Row>
                <Col xs={12} style={{width: 100, backgroundColor: '#F5F5F5', textAlign: 'center'}}>
                    <img src={'komune-logo-bw.png'} style={{width: 270, padding: 12, objectFit: 'contain'}}/>
                </Col>
            </Row>
            <Container style={{marginTop: 24}}>
                <Row>
                    <Col xs={12} style={{fontFamily: 'Archivo', fontWeight: 'bold', fontSize: 24, marginBottom: 8}}>
                        Hi, {user?.name}
                    </Col>

                    <Col xs={12} style={{fontFamily: 'Archivo', fontSize: 16, marginBottom: 24}}>
                        Your highlights from Kula Courts are ready, enjoy the moment!
                    </Col>

                    <Col xs={12} style={{fontFamily: 'Archivo', color: 'grey', fontSize: 15}}>
                        Kula Courts
                    </Col>

                    <Col xs={12} style={{fontFamily: 'Archivo', color: 'grey', fontSize: 15}}>
                        Court 1
                    </Col>

                    <Col xs={12} style={{fontFamily: 'Archivo', color: 'grey', fontSize: 15}}>
                        Thursday 12 June 2025
                    </Col>

                    <Col xs={12} style={{fontFamily: 'Archivo', color: 'grey', fontSize: 15, marginBottom: 36}}>
                        15:00 - 17:00
                    </Col>

                    {
                        recordings.map(recording => {
                            return (
                                <Col xs={12} md={6} lg={4}
                                     onClick={() => window.open(recording.recording_file)}
                                     style={{marginBottom: 24, cursor: 'pointer'}}>
                                    <div style={{position: 'relative'}} onClick={e => {
                                        e.stopPropagation()
                                        setSelectedRecording(recording)
                                    }}>


                                        <img
                                            src={recording.thumbnail}
                                            style={{
                                                height: 172,
                                                width: '100%',
                                                backgroundColor: 'grey',
                                                borderRadius: 6,
                                                marginBottom: 16
                                            }}/>

                                        <img src={'ic-play.png'} style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%,-50%)',
                                            width: 24,
                                            height: 24
                                        }}/>
                                    </div>


                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <div style={{fontFamily: 'Archivo', fontSize: 16}}>
                                            {moment.utc(recording.start_video).format('DD MMM YYYY, HH:mm')}
                                        </div>
                                        <div style={{
                                            backgroundColor: '#004936',
                                            color: 'white',
                                            padding: '10px 20px',
                                            borderRadius: 40,
                                            fontFamily: 'Work Sans',
                                            fontSize: 14
                                        }}>
                                            <img src={'ic-arrow-down.png'}
                                                 style={{width: 16, height: 16, marginRight: 8}}/>
                                            Download
                                        </div>
                                    </div>

                                    <div style={{width: '100%', height: 1, backgroundColor: '#EDEDED', marginTop: 26}}/>
                                </Col>
                            )
                        })
                    }

                    <Col xs={12} style={{
                        marginTop: 48,
                        backgroundColor: '#F5F5F5',
                        textAlign: 'center',
                        padding: 16,
                        marginBottom: 32
                    }}>
                        <div style={{fontFamily: 'Archivo', fontSize: 16, marginBottom: 4, fontWeight: 'bold'}}>
                            Link expires: {user?.recording_expired_at ? moment(user?.recording_expired_at).format(`DD MMMM YYYY`) : '31 June 2025'}
                        </div>

                        <div style={{fontFamily: 'Archivo', fontSize: 16}}>
                            This link is shareable, click <a href={'#'} onClick={e => {
                            e.preventDefault()

                            handleCopyClick()
                        }}>here</a> to copy link <br/>
                            Need help? Contact <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> / <a
                            href={`https://instagram.com/komunestudio`}>@komunestudio</a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}

export default App;
